import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoginNudgeStore = defineStore(
    'login_nudge',
    () => {
        const desktopGameTopBarSessionsShown = ref(0)
        const desktopFooterTooltipTimesShown = ref(0)

        function markGameDesktopTopBarShown() {
            desktopGameTopBarSessionsShown.value += 1
        }

        function markFooterDesktopTooltipShown() {
            desktopFooterTooltipTimesShown.value += 1
        }

        function reset() {
            desktopGameTopBarSessionsShown.value = 0
            desktopFooterTooltipTimesShown.value = 0
        }

        return {
            desktopGameTopBarSessionsShown,
            desktopFooterTooltipTimesShown,
            markGameDesktopTopBarShown,
            markFooterDesktopTooltipShown,
            reset,
        }
    },
    {
        persist: {
            key: 'login_nudge',
            pick: ['desktopGameTopBarSessionsShown', 'desktopFooterTooltipTimesShown'],
        },
    },
)
